(function () {
    'use strict';

    const formNewsletters = document.getElementById('form-newsletters');

    if (!formNewsletters) {
        return;
    }

    const messagesContainer = formNewsletters.querySelector('#messages');
    const newsletterFormContainer = formNewsletters.querySelector(
        '.form-newsletters-container'
    );
    const newsletterSubscribe = formNewsletters.querySelector(
        '#newsletter_subscribe'
    );
    const newsletterAgreement = formNewsletters.querySelector(
        '#newsletter_agreement'
    );
    const btnSubscriptionNewsletter = formNewsletters.querySelector(
        '#btn-subscription-newsletter'
    );
    const recaptchaElement = document.getElementById('recaptcha-invisible');
    const newsletterFailureMessage =
        formNewsletters.dataset.failureMessage ||
        'Email not added to the newsletter.';
    const newsletterRecaptchaVersion =
        formNewsletters.dataset.recaptchaVersion || null;
    const newsletterRecaptchaSiteKey =
        formNewsletters.dataset.recaptchaSiteKey || null;
    const maxRecaptchaRenderAttempts = 40;

    let newsletterRecaptchaWidgetId = null;
    let recaptchaRenderAttempts = 0;
    let recaptchaRenderTimer = null;
    let isSubmitting = false;

    if (
        !messagesContainer ||
        !newsletterFormContainer ||
        !newsletterSubscribe ||
        !newsletterAgreement ||
        !btnSubscriptionNewsletter
    ) {
        return;
    }

    function setNewsletterSubmitting(submitting) {
        isSubmitting = submitting;
        btnSubscriptionNewsletter.disabled = submitting;
        formNewsletters.setAttribute(
            'aria-busy',
            submitting ? 'true' : 'false'
        );
    }

    function resetNewsletterRecaptcha() {
        const recaptchaApi = window.grecaptcha;

        if (
            newsletterRecaptchaWidgetId !== null &&
            recaptchaApi &&
            typeof recaptchaApi.reset === 'function'
        ) {
            recaptchaApi.reset(newsletterRecaptchaWidgetId);
        }
    }

    function renderNewsletterRecaptcha() {
        if (!recaptchaElement || newsletterRecaptchaWidgetId !== null) {
            return;
        }

        const recaptchaApi = window.grecaptcha;

        if (!recaptchaApi || typeof recaptchaApi.render !== 'function') {
            if (
                recaptchaRenderAttempts >= maxRecaptchaRenderAttempts ||
                recaptchaRenderTimer !== null
            ) {
                return;
            }

            recaptchaRenderAttempts += 1;
            recaptchaRenderTimer = window.setTimeout(function () {
                recaptchaRenderTimer = null;
                renderNewsletterRecaptcha();
            }, 250);
            return;
        }

        newsletterRecaptchaWidgetId = recaptchaApi.render(recaptchaElement, {
            sitekey: recaptchaElement.getAttribute('data-sitekey'),
            size: 'invisible',
            callback: postNewsletterSubscription
        });
    }

    function showNewsletterRecaptchaFailure() {
        showNewsletterMessage('alert-warning', [newsletterFailureMessage]);
        setNewsletterSubmitting(false);
    }

    function executeNewsletterRecaptchaV3() {
        const recaptchaApi = window.grecaptcha;

        if (
            !recaptchaApi ||
            typeof recaptchaApi.ready !== 'function' ||
            typeof recaptchaApi.execute !== 'function'
        ) {
            showNewsletterRecaptchaFailure();
            return;
        }

        setNewsletterSubmitting(true);

        try {
            recaptchaApi.ready(function () {
                try {
                    Promise.resolve(
                        recaptchaApi.execute(newsletterRecaptchaSiteKey, {
                            action: 'newsletter'
                        })
                    )
                        .then(postNewsletterSubscription)
                        .catch(showNewsletterRecaptchaFailure);
                } catch (error) {
                    showNewsletterRecaptchaFailure();
                }
            });
        } catch (error) {
            showNewsletterRecaptchaFailure();
        }
    }

    function normalizeNewsletterMessages(data) {
        if (!data) {
            return [newsletterFailureMessage];
        }

        if (data.msg || data.message) {
            return [data.msg || data.message];
        }

        if (Array.isArray(data.error)) {
            return data.error;
        }

        if (data.error) {
            return [data.error];
        }

        if (data.errors) {
            const messages = Object.keys(data.errors)
                .reduce(function (result, key) {
                    const errors = Array.isArray(data.errors[key])
                        ? data.errors[key]
                        : [data.errors[key]];
                    return result.concat(errors);
                }, [])
                .filter(Boolean);

            return messages.length ? messages : [newsletterFailureMessage];
        }

        return [newsletterFailureMessage];
    }

    function showNewsletterMessage(type, messages) {
        messagesContainer.classList.remove(
            'alert',
            'alert-success',
            'alert-warning'
        );
        messagesContainer.classList.add('alert', type);
        messagesContainer.innerHTML = '';

        messages.forEach(function (message) {
            const paragraph = document.createElement('p');
            paragraph.textContent = message;
            messagesContainer.appendChild(paragraph);
        });
    }

    function refreshCsrfToken() {
        if (typeof updateCsrfToken !== 'function') {
            return Promise.resolve();
        }

        return new Promise(function (resolve, reject) {
            updateCsrfToken().done(resolve).fail(reject);
        });
    }

    async function postNewsletterSubscription(token) {
        setNewsletterSubmitting(true);

        const payload = {
            email: newsletterSubscribe.value,
            privacy: newsletterAgreement.checked
        };

        if (token) {
            payload['g-recaptcha-response'] = token;
        }

        try {
            await refreshCsrfToken();

            const response = await axios.post(
                btnSubscriptionNewsletter.getAttribute('data-url'),
                payload
            );

            if (response.data.success) {
                showNewsletterMessage(
                    'alert-success',
                    normalizeNewsletterMessages(response.data)
                );
                formNewsletters.reset();
                newsletterFormContainer.hidden = true;
            } else {
                showNewsletterMessage(
                    'alert-warning',
                    normalizeNewsletterMessages(response.data)
                );
            }
        } catch (error) {
            const responseData =
                error && error.response ? error.response.data : null;
            showNewsletterMessage(
                'alert-warning',
                normalizeNewsletterMessages(responseData)
            );
        } finally {
            resetNewsletterRecaptcha();
            setNewsletterSubmitting(false);
        }
    }

    renderNewsletterRecaptcha();

    formNewsletters.addEventListener('submit', function (event) {
        event.preventDefault();

        if (isSubmitting) {
            return;
        }

        if (
            !newsletterSubscribe.checkValidity() ||
            !newsletterAgreement.checkValidity()
        ) {
            if (typeof formNewsletters.reportValidity === 'function') {
                formNewsletters.reportValidity();
            }

            return;
        }

        if (newsletterRecaptchaVersion === 'v3' && newsletterRecaptchaSiteKey) {
            executeNewsletterRecaptchaV3();
            return;
        }

        if (recaptchaElement) {
            if (newsletterRecaptchaWidgetId === null) {
                renderNewsletterRecaptcha();
            }

            const recaptchaApi = window.grecaptcha;

            if (
                newsletterRecaptchaWidgetId !== null &&
                recaptchaApi &&
                typeof recaptchaApi.execute === 'function'
            ) {
                setNewsletterSubmitting(true);
                recaptchaApi.execute(newsletterRecaptchaWidgetId);
                return;
            }

            showNewsletterMessage('alert-warning', [newsletterFailureMessage]);
            return;
        }

        postNewsletterSubscription(null);
    });
})();
